import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, asyncScheduler, scheduled, throwError, lastValueFrom } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DialogService } from '../dialog.service';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {


    constructor(
        private _dialog: DialogService
    ) { }

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return scheduled(this.handle(req, next), asyncScheduler);
    }

    async handle(req: HttpRequest<any>, next: HttpHandler) {

        return await lastValueFrom(next.handle(req)
            .pipe(
                catchError((error) => {
                    console.error("Intercepted error ", error);

                    switch (error.status) {
                        case 400:
                            var errorObject: any;
                            if (error?.error instanceof Blob) {
                                var blobString = this.blobToString(error.error);
                                errorObject = JSON.parse(blobString);
                            } else if (typeof error?.error?.error === 'string') {
                                errorObject = error?.error?.error;
                            }
                            else {
                                errorObject = error.error.result.error;
                            }
                            this._dialog.ws400alert(errorObject);
                            break;

                        case 401: 
                            break;
                        case 403:
                            this._dialog.ws403alert();
                            break;

                        case 404:
                            this._dialog.ws404alert();
                            break;

                        default:
                            this._dialog.ws500alert();
                            break;
                    }
                    return throwError(() => error);
                })
            )
        );
    }



    private blobToString(blob): any {
        const url = URL.createObjectURL(blob);
        var xmlRequest = new XMLHttpRequest();
        xmlRequest.open('GET', url, false);
        xmlRequest.send();
        URL.revokeObjectURL(url);
        return xmlRequest.responseText;
    }
}
